/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type { GetRegisteredUsersReportAggregateByDayOptions, GetRegisteredUsersReportAggregateByDayStatus200, GetRegisteredUsersReportAggregateByDayStatus422 } from '../models/GetRegisteredUsersReportAggregateByDay'
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query'
import { getRegisteredUsersReportAggregateByDay } from '../clients/axios/getRegisteredUsersReportAggregateByDay'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getRegisteredUsersReportAggregateByDayQueryKey = ({ query }: Omit<GetRegisteredUsersReportAggregateByDayOptions, 'headers'>) => [{ url: '/reports/registered_users/aggregate-by-day' }, ...(query ? [query] : [])] as const

type GetRegisteredUsersReportAggregateByDayQueryKey = ReturnType<typeof getRegisteredUsersReportAggregateByDayQueryKey>

export function getRegisteredUsersReportAggregateByDayQueryOptions({ query }: GetRegisteredUsersReportAggregateByDayOptions, config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {}) {
  const queryKey = getRegisteredUsersReportAggregateByDayQueryKey({ query })
  return queryOptions<GetRegisteredUsersReportAggregateByDayStatus200, ResponseErrorConfig<GetRegisteredUsersReportAggregateByDayStatus422>, GetRegisteredUsersReportAggregateByDayStatus200, typeof queryKey>({
   queryKey,
   queryFn: async ({ signal }) => {
      return await getRegisteredUsersReportAggregateByDay({ ...config, query, signal: config.signal ?? signal, throwOnError: true })
   },
  })
}

/**
 * @summary Get Registered Users Aggregate By Day
 * {@link /reports/registered_users/aggregate-by-day}
 */
export function useGetRegisteredUsersReportAggregateByDay<TData = GetRegisteredUsersReportAggregateByDayStatus200, TQueryData = GetRegisteredUsersReportAggregateByDayStatus200, TQueryKey extends QueryKey = GetRegisteredUsersReportAggregateByDayQueryKey>({ query }: { query: GetRegisteredUsersReportAggregateByDayOptions['query'] | (() => GetRegisteredUsersReportAggregateByDayOptions['query']) }, options: {
  query?: Partial<QueryObserverOptions<GetRegisteredUsersReportAggregateByDayStatus200, ResponseErrorConfig<GetRegisteredUsersReportAggregateByDayStatus422>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
} = {}) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { query: typeof query === 'function' ? query() : query }
  const queryKey = resolvedOptions?.queryKey ?? getRegisteredUsersReportAggregateByDayQueryKey(resolvedParams)

  const queryResult = useQuery({
   ...getRegisteredUsersReportAggregateByDayQueryOptions(resolvedParams, config),
   ...resolvedOptions,
   queryKey,
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<GetRegisteredUsersReportAggregateByDayStatus422>> & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
